var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rectificat"},[_c('CommonHeader',{attrs:{"info":_vm.headerInfo}}),_c('CommonRectificatDetails',{attrs:{"info":_vm.recitificatInfo}}),_c('CommonPreview',{attrs:{"info":_vm.previewInfo}}),_c('CommonProblemDetails',{staticStyle:{"margin-bottom":"240px"},attrs:{"info":_vm.problemDetailsData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }